import { generatePath, NavLink } from "react-router-dom";

import Card from "~/components/Card/Card";
import { INVOICE_DETAILS_PATH } from "~/constants/appRoutes.ts";
import type { InvoiceCoreData } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";

type Props = { reversalInvoiceData: InvoiceCoreData | null; };

const ReversalInvoiceCard = ({ reversalInvoiceData }: Props) => {
	return <Card title="Storno-Rechnung">
		{reversalInvoiceData &&
			<NavLink className="hover:text-secondary-500"
					 to={generatePath(INVOICE_DETAILS_PATH, { invoiceId: reversalInvoiceData.id })}>{reversalInvoiceData.invoiceNumber}</NavLink>
		}
		{!reversalInvoiceData && "Storno Rechnung konnte nicht gefunden werden."}
	</Card>;
};

export default ReversalInvoiceCard;